import { render } from "./RequestsList.vue?vue&type=template&id=927466de&scoped=true"
import script from "./RequestsList.vue?vue&type=script&lang=js"
export * from "./RequestsList.vue?vue&type=script&lang=js"

import "./RequestsList.vue?vue&type=style&index=0&id=927466de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927466de"]])

export default __exports__